import { createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "transactions-history" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = {
  key: 3,
  class: "table-responsive-small"
}
const _hoisted_5 = { class: "text-right" }
const _hoisted_6 = { class: "payout-type text-center" }
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { class: "payout-status text-center" }
const _hoisted_9 = ["data-header"]
const _hoisted_10 = ["data-header"]
const _hoisted_11 = ["data-header"]
const _hoisted_12 = ["data-header"]
const _hoisted_13 = ["title", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Notification = _resolveComponent("Notification")!
  const _component_TransactionsHistorySkeleton = _resolveComponent("TransactionsHistorySkeleton")!
  const _component_PaginationDots = _resolveComponent("PaginationDots")!
  const _component_TransactionDetailsDialog = _resolveComponent("TransactionDetailsDialog")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("h2", null, [...(_cache[0] || (_cache[0] = [
      _createTextVNode(" Your History ", -1)
    ]))])), [
      [_directive_translate]
    ]),
    (_ctx.error)
      ? (_openBlock(), _createBlock(_component_Notification, {
          key: 0,
          "icon-name": "danger",
          title: _ctx.$gettext('Failed retrieving your history'),
          message: _ctx.error
        }, null, 8, ["title", "message"]))
      : _createCommentVNode("", true),
    (!_ctx.history)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_TransactionsHistorySkeleton),
          _createVNode(_component_PaginationDots, {
            "current-page": _ctx.paginationCache.currentPage,
            "pages-count": _ctx.paginationCache.pagesCount
          }, null, 8, ["current-page", "pages-count"])
        ]))
      : (!_ctx.history.data.length)
        ? _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_3, [...(_cache[1] || (_cache[1] = [
            _createTextVNode(" You haven't made any payout request yet. ", -1)
          ]))])), [
            [_directive_translate]
          ])
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("table", null, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _withDirectives((_openBlock(), _createElementBlock("th", _hoisted_5, [...(_cache[2] || (_cache[2] = [
                    _createTextVNode(" Payout ", -1)
                  ]))])), [
                    [_directive_translate]
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("th", _hoisted_6, [...(_cache[3] || (_cache[3] = [
                    _createTextVNode(" Payout Type ", -1)
                  ]))])), [
                    [_directive_translate]
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("th", _hoisted_7, [...(_cache[4] || (_cache[4] = [
                    _createTextVNode(" Requested On ", -1)
                  ]))])), [
                    [_directive_translate]
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("th", _hoisted_8, [...(_cache[5] || (_cache[5] = [
                    _createTextVNode(" Status ", -1)
                  ]))])), [
                    [_directive_translate]
                  ])
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.history.data, (transaction) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: transaction.id,
                    class: "transaction-row"
                  }, [
                    _createElementVNode("td", {
                      "data-header": _ctx.$gettext('Payout'),
                      class: "text-right"
                    }, _toDisplayString(( transaction.requestedAmount && transaction.requestedCurrency )
                  ? _ctx.formatPrice(transaction.requestedAmount, transaction.requestedCurrency)
                  : _ctx.formatPrice(transaction.amount, 'GBP')), 9, _hoisted_9),
                    _createElementVNode("td", {
                      "data-header": _ctx.$gettext('Payout Type'),
                      class: "payout-type text-center"
                    }, _toDisplayString(transaction.type), 9, _hoisted_10),
                    _createElementVNode("td", {
                      "data-header": _ctx.$gettext('Requested On'),
                      class: "text-center"
                    }, _toDisplayString(_ctx.formatDate(transaction.createdAt)), 9, _hoisted_11),
                    _createElementVNode("td", {
                      "data-header": _ctx.$gettext('Status'),
                      class: "payout-status text-center"
                    }, [
                      _createElementVNode("strong", {
                        class: _normalizeClass(_ctx.getStatusClass(transaction.status))
                      }, _toDisplayString(_ctx.$gettext(_ctx.getStatusText(transaction.status))), 3)
                    ], 8, _hoisted_12),
                    _createElementVNode("td", null, [
                      _createElementVNode("a", {
                        class: "more-details",
                        href: "#",
                        title: _ctx.$gettext('View details'),
                        onClick: _withModifiers(($event: any) => (_ctx.openTransactionDetails(transaction.id)), ["prevent"])
                      }, " … ", 8, _hoisted_13)
                    ])
                  ]))
                }), 128))
              ])
            ]),
            (_ctx.history.meta.pagesCount > 1)
              ? (_openBlock(), _createBlock(_component_PaginationDots, {
                  key: 0,
                  "current-page": _ctx.history.meta.currentPage,
                  "pages-count": _ctx.history.meta.pagesCount,
                  onSelectPage: _ctx.fetchHistory
                }, null, 8, ["current-page", "pages-count", "onSelectPage"]))
              : _createCommentVNode("", true),
            _createVNode(_component_TransactionDetailsDialog, { ref: "transactionDetailsDialog" }, null, 512)
          ]))
  ]))
}